const OPTIONS = [
  { v: 'trace',   label: 'Trace' },
  { v: 'density', label: 'Density' },
  { v: 'grid',    label: 'Grid' }
]

export default function WeekViewModeToggle ({ vizStyle, setVizStyle }) {
  return (
    <div style={{
      display: 'flex', background: '#efe9da', borderRadius: 8, padding: 2, gap: 1
    }}>
      {OPTIONS.map(o => {
        const on = vizStyle === o.v
        return (
          <button
            key={o.v}
            onClick={() => setVizStyle(o.v)}
            style={{
              padding: '4px 10px', borderRadius: 6, border: 'none', cursor: 'pointer',
              fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
              background: on ? '#fbf8f1' : 'transparent',
              color: on ? '#1c2419' : '#8a8472',
              boxShadow: on ? '0 1px 2px rgba(28,36,25,0.12)' : 'none',
              transition: 'all 0.12s'
            }}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
